/**
 * utils.js
 *
 * A selection of useful DOM utilities.
 */
import * as errors from '@js/constants/errors';
/**
 * Gets the closest parent that matches the selector up the DOM tree.
 */
var matches = function (el, selector) {
    // Search for the closest match of the selector.
    for (; el; el = el.parentNode) {
        if (typeof el.matches === 'function' && el.nodeType === Node.ELEMENT_NODE && el.matches(selector)) {
            return el;
        }
    }
    return null;
};
/**
 * Checks to see if a credit card number matches one of the providers.
 */
var getCardType = function (number) {
    if (/^5[1-5][0-9]{14}|^2[2-7][2-2][0-9]{13}$/.test(number)) {
        // Mastercard.
        return 'M';
    }
    else if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(number)) {
        // Visa.
        return 'V';
    }
    else if (/^3[47][0-9]{13}$/.test(number)) {
        // American Express.
        return 'A';
    }
    return false;
};
/**
 * Checks support for IntersectionObserver.
 */
var supportsIntersectionObserver = function () {
    return 'IntersectionObserver' in window;
};
/**
 * Copies a value to the clipboard.
 */
var copy = function (value) {
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(value);
    }
    return Promise.reject(errors.CLIPBOARD_UNSUPPORTED);
};
/**
 * Uses an IntersectionObserver to only load an app when it comes into view.
 */
var observeApp = function (element, options, callback) {
    if (!supportsIntersectionObserver()) {
        callback();
        return;
    }
    var defaults = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    };
    options = Object.assign({}, defaults, options);
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                callback();
                observer.unobserve(element);
            }
        });
    }, options);
    observer.observe(element);
};
/**
 * Only fire a function after given time (seconds) has lapsed and not as quickly as it is triggered
 */
var debounce = function (func, time) {
    var timeout = null;
    return function () {
        clearTimeout(timeout);
        var args = arguments;
        var that = this;
        timeout = setTimeout(function () {
            func.apply(that, args);
        }, time);
    };
};
export { matches, getCardType, supportsIntersectionObserver, copy, observeApp, debounce };
